import React, { FC, useMemo } from 'react'
import { Menu } from '@material-ui/icons'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles'
import { darkTheme } from 'src/theme'
import { useLocation } from 'react-router'
import { LayoutNavigation } from '../organisms/layout/layout-navigation'
import { LayoutHeader } from '../organisms/layout/layout-header'
import { LayoutContent } from '../organisms/layout/layout-content'
import { NavContent } from '../organisms/nav-content'
import { NavHeader } from '../molecules/nav-header'
import { MessagingCmsBanner } from '../molecules/messaging-cms-banner'
import { HeaderBar } from '../organisms/header-bar'
import { CellularPayPrompt, CellularUpcomingPrompt } from '../organisms/cellular-pay-prompt'
import { COLOR_DARKER_GRAY_1 } from '../../constants/style'
import useWorkspaceId from '../../hooks/useWorkspaceId'
import { BannerSlotProvider } from '../organisms/cellular-pay-prompt/banner-slot'

const isMatchPlayListUrl = url => {
  if (!url.match(/playlists/)) {
    return false
  }

  return url.match(
    /playlists\/(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})|(?:new)/
  )
}

export const PrivateLayout: FC = ({ children }) => {
  const { pathname } = useLocation()
  const workspaceId = useWorkspaceId()

  return (
    <>
      <LayoutHeader
        menuIcon={{
          show: <Menu />,
          hide: <Menu />,
          expand: <Menu />
        }}
        style={{ backgroundColor: COLOR_DARKER_GRAY_1 }}
      >
        <HeaderBar />
      </LayoutHeader>
      {!pathname.endsWith('/lobby') &&
        <MuiThemeProvider theme={darkTheme}>
          <LayoutNavigation
            header={({ collapsed, collapsible }) => (
              <NavHeader
                collapsed={collapsed}
                collapsible={collapsible}
              />
            )}
          >
            <NavContent />
          </LayoutNavigation>
        </MuiThemeProvider>}

      <LayoutContent>
        <BannerSlotProvider>
          {/* Mounted once for every authenticated page (it used to hang off
            AppBarWithButton, so three pages blocked and the rest did not). */}
          <CellularPayPrompt workspaceId={workspaceId} />
          {/* SHA-973 P4c: "Set up auto-pay" before the included cellular ends (owner only). */}
          <CellularUpcomingPrompt />
          <MessagingCmsBanner />
          {children}
        </BannerSlotProvider>
      </LayoutContent>
    </>
  )
}
